"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icon = (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        var sizeNumber = '16';
        if (this.props.size === 'medium') {
            sizeNumber = '20';
        }
        else if (this.props.size === 'large') {
            sizeNumber = '24';
        }
        var className = "abb_icon_" + sizeNumber + " ui_" + this.props.icon;
        return (React.createElement("span", __assign({}, this.props, { ref: this.props.ref, className: className, "aria-hidden": 'true', style: { color: this.props.color, visibility: this.props.visibility === 'hidden' ? 'hidden' : 'visible' } })));
    };
    return Icon;
}(React.Component));
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map